const isFetchingSelector = ({ galleriesListState }) => galleriesListState.isFetching
const galleriesListSelector = ({ galleriesListState }) => galleriesListState.galleriesList

export {
  isFetchingSelector,
  galleriesListSelector
}
